import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import { getDataPointsForUnitController } from '@src/sld/utils';
import { ReactElement } from 'react';
import { UnitController, UnitControllerSN } from '../devicePointsConfig';
import Unit from './Unit';

type C_UnitsProps = {
  unitControllersWithDataPointValues: UnitController[];
};

function C_Units(props: C_UnitsProps): ReactElement {
  const { unitControllersWithDataPointValues } = props;

  return (
    <>
      <HorizontalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={455}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2C1'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_C1,
        )}
        rectangleXCoordinate='295'
        rectangleYCoordinate='200'
        textStartingXCoordinate={300}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={425}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2C2'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_C2,
        )}
        rectangleXCoordinate='385'
        rectangleYCoordinate='200'
        textStartingXCoordinate={390}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={515}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2C3'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_C3,
        )}
        rectangleXCoordinate='475'
        rectangleYCoordinate='200'
        textStartingXCoordinate={480}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={605}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />

      <Unit
        label={'F2C4'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_C4,
        )}
        rectangleXCoordinate='565'
        rectangleYCoordinate='200'
        textStartingXCoordinate={570}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={695}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2C5'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_C5,
        )}
        rectangleXCoordinate='655'
        rectangleYCoordinate='200'
        textStartingXCoordinate={660}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={785}
        translateYCoordinate={140}
        length={35}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={785}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2C6'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_C6,
        )}
        rectangleXCoordinate='745'
        rectangleYCoordinate='200'
        textStartingXCoordinate={750}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />
    </>
  );
}

export default C_Units;
